import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { getUniqueBodyStyles } from '../../../redux/selectors/models';
import { geti18n } from '../../../utils';
import BodyStyleFilterItem from './BodyStyleFilterItem';

/**
 * Component for Vehicle selection Grid to filter out options other
 * than the selected body style (Car, Truck, etc)
 */
class BodyStyleFilter extends Component {
  static propTypes = {
    bodyStyles: PropTypes.array.isRequired,
    allVehiclesText: PropTypes.string.isRequired,
  };

  static defaultProps = {
    allVehiclesText: geti18n('trimFilter.allVehicles'),
  };

  renderBodyFilterItems() {
    const { bodyStyles } = this.props;
    return bodyStyles.map(bodyStyle => (
      <BodyStyleFilterItem
        key={bodyStyle.slug}
        id={bodyStyle.slug}
        title={bodyStyle.name}
      />
    ))
  }

  render() {
    const { allVehiclesText } = this.props;

    return (
      <ul className="list-checkbox">
        <BodyStyleFilterItem key="all" id="all" title={`${allVehiclesText}`} />
        {this.renderBodyFilterItems()}
      </ul>
    );
  }
}

const mapStateToProps = state => ({
  bodyStyles: getUniqueBodyStyles(state),
});

export default connect(mapStateToProps)(BodyStyleFilter);



/** WEBPACK FOOTER **
 ** ./src/pages/ModelLineSelect/BodyStyleFilter/index.js
 **/